import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/oxs6r0ng_Screenshot_20260215_173129_Gmail.jpg';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  const services = [
    { name: 'Plumbing Repairs', path: '/services/plumbing-repairs' },
    { name: 'Electric Boiler Services', path: '/services/electric-boiler' },
    { name: 'Water Filtration', path: '/services/water-filtration' },
    { name: 'In-Floor Heating', path: '/services/in-floor-heating' },
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#005B96] text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Duncan's Plumbing Logo"
                className="h-16 w-auto bg-white rounded-lg p-1"
              />
            </Link>
            <h3 className="font-bold text-xl mb-2">Duncan's Plumbing Heating and Filtration</h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Licensed local plumbers serving Yarmouth, Digby and Shelburne Counties with plumbing, heating, sewer, and water filtration services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/80 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-white/80 hover:text-white transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:902-746-0554"
                  className="flex items-center gap-3 text-white/80 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} />
                  <span>902-746-0554</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-white/80">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <span data-testid="footer-address">
                    632 Main St<br />
                    Yarmouth, NS B5A 1K3
                  </span>
                </div>
              </li>
            </ul>

            {/* Social Links */}
            <div className="mt-6">
              <h5 className="font-semibold mb-3">Follow Us</h5>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/share/17tR8zcD4Q/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition-colors"
                  data-testid="footer-facebook"
                  aria-label="Facebook"
                >
                  <Facebook size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {currentYear} Duncan's Plumbing Heating & Filtration. All rights reserved.
            </p>
            <p className="text-white/60 text-sm">
              Serving Yarmouth County, Nova Scotia
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
